import styled from 'styled-components';

export const ToolbarContainer = styled.div`
  background-color: ${({ theme }) => theme.colors.backgroundColor};
  height: 64px;
  box-shadow: ${({ theme }) => theme.shadows.default};
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  border-radius: 6px;
`;

export const ToolbarLogo = styled.img`
  height: 24px;
`;

export const ToolbarOsLogo = styled.img`
  height: 40px;
`;
